export enum ESuburbanWCType {
  Any = 0,
  Inside = 1,
  Outside = 2,
}
